<template>
	<v-card 
		class="pa-4"
		color="grey lighten-5"
		elevation="0"
	>
		<v-alert type="info" class="mb-4" color="teal darken-2">
			<div>
				This client is currently enrolled.
			</div>
			<v-divider />
			<div style="font-size: 80%;">
				Choose More &gt; Archive to remove this enrollment but keep the client information.
			</div>
		</v-alert>
		<v-card class="mb-2">
			<v-container fluid>
				<v-row dense>
					<v-col :cols="12" lg="6" md="6" sm="6" xs="12">
						<div class="overline">Client:</div>
						<div class="caption">
							<data-string :value="value.client.clientCode" />
						</div>
						<div>
							<data-string :value="value.client.summary" />
						</div>
						<div>
							<data-string :value="value.client.emailAddress" />
						</div>
						<div>
							<data-string :value="value.client.phoneNumber" />
						</div>
					</v-col>
				</v-row>
			</v-container>
			<div class="pa-4">
				<v-btn dark color="primary" :to="tools.linkToDetail({ namespace: 'people', pluralName: 'clients', id: value.client.id })">View Client Detail</v-btn>
			</div>
		</v-card>
	</v-card>
</template>

<script>
import apiService from '@/apiService';
import tools from '@/tools';
import moment from 'moment';
import DataString from '@/components/pieces/DataString';
import DataInteger from '@/components/pieces/DataInteger';
export default {
	components: {
		DataString,
		DataInteger
	},
	props: {
		routeInfo: {
			type: Object
		},
		value: {
			type: Object
		},
		isBase: {
			type: Boolean,
			default: true
		},
		headerColor: {
			type: String,
			default: 'primary'
		}
	},
	data() {
		return {
			loaders: {

			},
			tools
		}
	}
}
</script>